import Title from "../components/TheTitle.vue";
import { getBrandsMaster, getCouponTargetProductsMaster, searchCoupon, } from "../api";
import { Validation } from "../utils/validation";
import * as DOMPurifyModule from "dompurify";
import { FormatDate } from "../utils/formatDate";
import { Authorize } from "../utils/authorize";
export default {
    name: "couponSearch",
    data() {
        return {
            infoPage: 1,
            pageSize: 100,
            tableInfo: [],
            brandInfo: [],
            targetProduct: [],
            form: {
                coupon_code: "",
                brand_id: "",
                coupon_name: "",
                target_product_id: "",
                expiration_date_from: "",
                expiration_date_to: "",
                discount: "",
                discount_unit: "",
                term_of_use: "",
                publisher: "",
                only_valid: false,
            },
            showModal: false,
            modalText: "",
        };
    },
    components: {
        Title,
    },
    computed: {
        infoTotalPages() {
            return Math.max(1, Math.ceil(this.tableInfo.length / this.pageSize));
        },
        pagedInfo() {
            const start = (this.infoPage - 1) * this.pageSize;
            return this.tableInfo.slice(start, start + this.pageSize);
        },
    },
    watch: {
        "form.discount_unit": async function (newVal, oldVal) {
            if (!oldVal)
                return;
            this.form.discount = "";
        },
    },
    methods: {
        setInfoPage(p) {
            if (p < 1)
                p = 1;
            if (p > this.infoTotalPages)
                p = this.infoTotalPages;
            this.infoPage = p;
        },
        openModal(html) {
            const DOMPurify = DOMPurifyModule.default || DOMPurifyModule;
            this.modalText = DOMPurify.sanitize(html || "");
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
            this.modalText = "";
        },
        onKeydown(e) {
            if (e.key === "Escape" && this.showModal) {
                this.closeModal();
            }
        },
        formatDate(value) {
            return FormatDate.withoutTime(value);
        },
        goToDetail(couponCode) {
            this.$router.push(`/couponDetail/${couponCode}`);
        },
        exportCsv() {
            if (!this.tableInfo.length) {
                this.$store.commit("setMessages", ["出力対象のデータが存在しません。"]);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
                return;
            }
            // 1) ヘッダを作成
            const header = [
                "クーポンコード",
                "ブランド",
                "クーポン名",
                "対象商品",
                "詳細説明",
                "割引額・割引率",
                "利用条件",
                "有効期限",
                "利用可能回数",
                "発行者",
            ];
            // 2) tableInfo から値を取得（空文字や null は空文字に）
            const rows = this.tableInfo.map((t) => [
                t.coupon_code,
                t.brand,
                t.coupon_name,
                t.target_product,
                t.detailed_description,
                t.discount + (t.discount_unit === 0 ? "円" : "%"),
                t.term_of_use,
                this.formatDate(t.expiration_date),
                t.available_times,
                t.publisher,
            ]);
            // 3) CSV を作る
            const escapeCsv = (value) => {
                if (value == null)
                    return "";
                const v = String(value);
                return v;
            };
            const lines = [];
            lines.push(header.map(escapeCsv).join(","));
            for (const r of rows) {
                lines.push(r.map(escapeCsv).join(","));
            }
            let csvContent = lines.join("\r\n");
            // 4) Excel で文字化けしにくくするために UTF-8 BOM を付与（不要なら削除）
            const bom = "\uFEFF";
            const blob = new Blob([bom + csvContent], {
                type: "text/csv;charset=utf-8;",
            });
            // 5) ダウンロード処理
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            // ファイル名（任意）
            a.download = "クーポン検索_検索結果.csv";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        },
        onClear() {
            this.form = {
                coupon_code: "",
                brand_id: "",
                coupon_name: "",
                target_product_id: "",
                expiration_date_from: "",
                expiration_date_to: "",
                discount: "",
                discount_unit: "",
                term_of_use: "",
                publisher: "",
                only_valid: false,
            };
        },
        async onSearch() {
            const onlyValid = this.form.only_valid ? new Date() : null;
            const params = {
                coupon_code: (this.form.coupon_code || null),
                brand_id: (this.form.brand_id || null),
                coupon_name: (this.form.coupon_name || null),
                target_product_id: (this.form.target_product_id || null),
                expiration_date_from: onlyValid
                    ? onlyValid
                    : (this.form.expiration_date_from || null),
                expiration_date_to: onlyValid
                    ? null
                    : (this.form.expiration_date_to || null),
                discount_min: (this.form.discount || null),
                discount_max: (this.form.discount || null),
                discount_unit: (this.form.discount_unit || null),
                term_of_use: (this.form.term_of_use || null),
                publisher: (this.form.publisher || null),
            };
            const errorMessage = this.validate(params);
            if (errorMessage) {
                this.$store.commit("setMessages", errorMessage);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
                return;
            }
            const response = await searchCoupon(params.coupon_code, params.brand_id, params.coupon_name, params.target_product_id, params.expiration_date_from, params.expiration_date_to, params.discount_min, params.discount_max, params.discount_unit, params.term_of_use, params.publisher);
            if (response.result?.code === 9) {
                this.$store.commit("setMessages", response.result.messages);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
            }
            else {
                this.tableInfo = response.data.results;
                this.infoPage = 1;
            }
        },
        validate(params) {
            // エラーメッセージを格納する配列
            const errors = [];
            // 桁数チェック
            errors.push(...Validation.digitsMax({
                key: "クーポンコード",
                value: params.coupon_code,
            }, 9));
            errors.push(...Validation.digitsMax({
                key: "クーポン名",
                value: params.coupon_name,
            }, 100));
            errors.push(...Validation.digitsMax({
                key: "割引額・割引率",
                value: params.discount_min,
            }, 6));
            errors.push(...Validation.digitsMax({
                key: "利用条件",
                value: params.term_of_use,
            }, 100));
            errors.push(...Validation.digitsMax({
                key: "発行者",
                value: params.publisher,
            }, 100));
            // 属性チェック
            if (params.coupon_code) {
                errors.push(...Validation.isNotContainSymbols({
                    key: "クーポンコード",
                    value: params.coupon_code,
                }));
            }
            if (params.discount_max) {
                errors.push(...Validation.isInteger({
                    key: "割引額・割引率",
                    value: params.discount_max,
                }));
            }
            // 相関チェック
            if (params.expiration_date_from &&
                params.expiration_date_to &&
                params.expiration_date_from > params.expiration_date_to) {
                errors.push("有効期間のFromとToは、FromがToより小さくなるように入力してください。");
            }
            if (Number(params.discount_unit) === 1 &&
                Number(params.discount_max) > 100) {
                errors.push("割引単位に%を選択時は割引率に100以内の値を選択してください。");
            }
            if (errors.length > 0) {
                return errors;
            }
            return "";
        },
        isExpired(date) {
            if (!date)
                return false;
            const d = typeof date === "string" ? new Date(date) : date;
            if (Number.isNaN(d.getTime()))
                return false;
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const target = new Date(d.getFullYear(), d.getMonth(), d.getDate());
            return target < today; // 今日より前なら true
        },
    },
    async mounted() {
        if (await Authorize.isExpired(this)) {
            const gBMResponse = await getBrandsMaster();
            if (gBMResponse.result?.code === 9) {
                this.$store.commit("setMessages", gBMResponse.result.messages);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
                return;
            }
            else {
                this.brandInfo = gBMResponse.data.results;
            }
            const gCTPMResponse = await getCouponTargetProductsMaster();
            if (gCTPMResponse.result?.code === 9) {
                this.$store.commit("setMessages", gCTPMResponse.result.messages);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
                return;
            }
            else {
                this.targetProduct = gCTPMResponse.data.results;
            }
            window.addEventListener("keydown", this.onKeydown);
        }
    },
    beforeUnmount() {
        window.removeEventListener("keydown", this.onKeydown);
    },
};
